import { useIntl } from 'react-intl';

export interface ShippingMessageProps {
    c_dropshipEstimatedDeliveryDate?: string;
    c_dropshipEstimatedProcessingDate?: string;
}

export const useEstimatedDeliveryMessage = ({
    c_dropshipEstimatedDeliveryDate,
    c_dropshipEstimatedProcessingDate,
}: ShippingMessageProps): string | null => {
    const intl = useIntl();

    if (c_dropshipEstimatedDeliveryDate) {
        if (c_dropshipEstimatedDeliveryDate.includes('weeks')) {
            return intl.formatMessage(
                {
                    id: 'drop-shipping-edd-weeks',
                    defaultMessage: '{edd} for delivery',
                },
                {
                    edd: c_dropshipEstimatedDeliveryDate,
                },
            );
        }
        return intl.formatMessage(
            {
                id: 'drop-shipping-edd',
                defaultMessage: '{edd} business days for delivery',
            },
            {
                edd: c_dropshipEstimatedDeliveryDate?.split(' days')?.[0],
            },
        );
    }

    if (c_dropshipEstimatedProcessingDate) {
        if (c_dropshipEstimatedProcessingDate.includes('weeks')) {
            return intl.formatMessage(
                {
                    id: 'drop-shipping-processing-weeks',
                    defaultMessage: 'Allow {processingDate} for product to ship',
                },
                {
                    processingDate: c_dropshipEstimatedProcessingDate,
                },
            );
        }

        if (c_dropshipEstimatedProcessingDate.includes('hours')) {
            return intl.formatMessage(
                {
                    id: 'drop-shipping-processing-hours',
                    defaultMessage: 'Allow {processingDate} for product to ship',
                },
                {
                    processingDate: c_dropshipEstimatedProcessingDate,
                },
            );
        }

        return intl.formatMessage(
            {
                id: 'drop-shipping-processing-days',
                defaultMessage: 'Allow {processingDate} for product to ship',
            },
            {
                processingDate: c_dropshipEstimatedProcessingDate,
            },
        );
    }

    return null;
};
